import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

import { ReviewFooter } from "../../Footer/Footer";
import { PasswordVerification } from "./PasswordVerification";
import { getImageUrl } from "../../utils/images";
import { showMessage, showSpinner } from "../../utils/alerts";
import { changePassword } from "../../service/authServie";
import Swal from "sweetalert2";
import { showMessageCustom } from "../../utils/alertwithcustomfunc";

export const ResetOldPassword = (firstTimeLogin) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const userstate = useSelector((state) => state.user);
  const navigator = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldpasswordError, setOdlPasswordError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [confirmError, setConfirmError] = useState("");
  const [showoldpassword, setShowoldpassword] = useState(false);
  const [shownewpassword, setShownewpassword] = useState(false);
  const [showconfirmpassword, setShowconfirmpassword] = useState(false);

  const [policies, setPolicies] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    digit: false,
    special: false,
  });

  const validatePassword = (password) => {
    const updatedPolicies = {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      digit: /[0-9]/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    };
    setPolicies(updatedPolicies);

    const allValid = Object.values(updatedPolicies).every(Boolean);
    return allValid;
  };

  const handleNewPasswordChange = (e) => {
    const password = e.target.value;
    setNewPassword(password);

    if (!validatePassword(password)) {
      setPasswordError("Your password must meet the following criteria:");
    } else {
      setPasswordError("");
    }
  };

const handleConfirmPasswordChange = (e) => {
  const password = e.target.value;
  console.log("Entered confirm password:", password);

  setConfirmPassword(password);

  console.log("Current new password:", newPassword);

  if (password !== newPassword) {
    console.log("Passwords do not match.");
    setConfirmError("The new password and confirm password do not match.");
  } else {
    console.log("Passwords match.");
    setConfirmError("");
  }
};


  const handleSubmit = async (e) => {
  e.preventDefault();
  console.log("Submit triggered");

  if (oldPassword.length === 0) {
    console.log("Old password is empty");
    setOdlPasswordError("Please enter your current password.");
    return;
  }

  if (!validatePassword(newPassword)) {
    console.log("New password did not pass validation");
    setPasswordError("Your password must meet the following criteria:");
    return;
  }

  if (newPassword !== confirmPassword) {
    console.log("New and confirm password do not match");
    setConfirmError("The new password and confirm password do not match.");
    return;
  }

  console.log("User state before request:", userstate);

  setIsLoading(true);
  console.log("Loading started");
  showSpinner(
    "Updating",
    "Your password update is in progress. Please wait..."
  );

  try {
    const response = await changePassword(oldPassword, confirmPassword);
    console.log("API response received:", response);

    if (response.data.message === "password-changed-successfully") {
      console.log("Password change successful");
      setIsLoading(false);
      Swal.close();

      showMessageCustom(
        "Your password has been updated successfully.",
        "",
        () => {
          console.log("OK button clicked - navigating to dashboard");
          navigator("/dashboard");
        }
      );
      return;
    } else {
      console.log("Password change failed:", response);
      setIsLoading(false);
      Swal.close();
      showMessage(response?.data.message);
      return;
    }
  } catch (error) {
    console.log("Error during password change:", error);
    setIsLoading(false);
    Swal.close();
    showMessage("An error occurred. Please try again.");
  }

  setIsLoading(false);
};

  const GenerateEmailUrl = (userInfo) => {
    // Example email and isAuthenticated value
    // setEmail(userInfo.email)
    // setIsAuthenticatedFlasg('true')
    // const isAuthenticated = "true";

    // Encode the parameters using btoa
    const encodedEmail = btoa(userInfo.email); // Encodes the email
    const encodedIsAuthenticated = btoa("true"); // Encodes the isAuthenticated flag

    const queryParams = `?email=${encodedEmail}&isAuthenticated=${encodedIsAuthenticated}`;
    console.log("Generated queryParams:", queryParams);

    // Navigate to the reset-password route with query params
    navigate(`/reset-password${queryParams}`);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-20 col-md-8 px-40">
          <div className="left-title-bg">
            <p className="left-title">Reset your password</p>
          </div>
          <div className="content tracking">
            {/* <ReviewHeader /> */}
            {/* <p className="mb-0 font-20 font-md-30 font-weight-800">
              Reset your password
            </p> */}
            {/* <p>Reset Your Password to Secure Your Account.</p> */}
            {/*           
            {decodedIsAuthenticated === 'true' && decodedEmail && (
              <div>
                {console.log("userStateresetpassword",userstate)}
                <PasswordVerification decodedEmail={decodedEmail}/>
             
              </div>
            )}

            {step === 'otpVerification' && (
              <div>
                <h1>Enter OTP</h1>
                <form
                  onSubmit={e => {
                    e.preventDefault()
                    console.log('OTP entered:', otp)
                    // Simulate OTP verification and redirect to reset password
                    const encodedEmail = btoa(email)
                    navigate(
                      `/reset-password?email=${encodeURIComponent(
                        encodedEmail
                      )}&isAuthenticated=false`
                    )
                    console.log('OTP verified successfully!')
                  }}
                >
                  <input
                    type='text'
                    placeholder='Enter OTP'
                    value={otp}
                    onChange={e => {
                      setOtp(e.target.value)
                      console.log('OTP state updated:', e.target.value)
                    }}
                    required
                  />
                  <button type='submit'>Verify OTP</button>
                </form>
              </div>
            )} */}
            <div class="align-center justify-content-center">
              <div class="text-center w-100 pr-60 ">
                {/* <img
          src={getImageUrl('login-image.svg')}
          alt='img'
          class='w-100 mb-40 d-md-none'
        /> */}

                <h1 class="font-20 font-weight-600 my-25">
                  {/* {otpRecieved ? '' : 'Verify User'} */}
                </h1>

                <form id="forgot">
                  <div className="row form-default">
                    <div class="col-12 align-items-start col-md-8 login-field align-center text-left mb-3">
                      <div class="mr-3">
                        <img src={getImageUrl("icon-lock.svg")} alt="img" />
                      </div>
                      <div class="form-group w-100">
                        <label>Current password</label>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignContent: "center",
                            justifyContent: "flex-end",
                            alignItems: "center",
                          }}
                        >
                          <input
                            aria-valuenow={"Current password"}
                            type={showoldpassword ? "text" : "password"}
                            id="currentPassword"
                            value={oldPassword}
                            onChange={(e) => {
                              setOldPassword(e.target.value);
                              oldPassword.length === 0
                                ? setOdlPasswordError(
                                    "Please enter your current password."
                                  )
                                : setOdlPasswordError("");
                            }}
                            name="current-password"
                            class="form-control"
                            placeholder="Enter your current password"
                          />

                          <span
                            onClick={() => setShowoldpassword(!showoldpassword)}
                            className="position-absolute mx-2 end-0 right-0 top-50 translate-middle-y me-3 mx-2 cursor-pointer"
                            style={{ cursor: "pointer" }}
                          >
                            {
                              <img
                                src={
                                  !showoldpassword
                                    ? getImageUrl("eye-close.svg")
                                    : getImageUrl("eye-open.svg")
                                }
                                alt="img"
                              />
                            }
                          </span>
                        </div>
                        {oldpasswordError && (
                          <p style={{ color: "red" }}>{oldpasswordError}</p>
                        )}
                      </div>
                    </div>
                    <div class="col-12 align-items-start col-md-8 login-field align-center mx-2 text-left mb-3">
                      <div class="mr-3">
                        <img src={getImageUrl("icon-lock.svg")} alt="img" />
                      </div>

                      <div class="form-group w-100">
                        <label>New password</label>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignContent: "center",
                            justifyContent: "flex-end",
                            alignItems: "center",
                          }}
                        >
                          <input
                            aria-valuenow={"New password"}
                            id="newPassword"
                            type={shownewpassword ? "text" : "password"}
                            value={newPassword}
                            onChange={handleNewPasswordChange}
                            name="new-password"
                            class="form-control"
                            placeholder="Enter your new password"
                          />
                          <span
                            onClick={() => setShownewpassword(!shownewpassword)}
                            className="position-absolute end-0 top-50 translate-middle-y me-3 mx-2  cursor-pointer"
                            style={{ cursor: "pointer" }}
                          >
                            {
                              <img
                                src={
                                  !shownewpassword
                                    ? getImageUrl("eye-close.svg")
                                    : getImageUrl("eye-open.svg")
                                }
                                alt="img"
                              />
                            }
                          </span>
                        </div>
                        {passwordError && (
                          <p style={{ color: "red" }}>{passwordError}</p>
                        )}
                        <ul style={{ marginTop: "10px", paddingLeft: "20px" }}>
                          <li
                            style={{ color: policies.length ? "green" : "red" }}
                          >
                            At least 8 characters
                          </li>
                          <li
                            style={{
                              color: policies.uppercase ? "green" : "red",
                            }}
                          >
                            At least one uppercase letter
                          </li>
                          <li
                            style={{
                              color: policies.lowercase ? "green" : "red",
                            }}
                          >
                            At least one lowercase letter
                          </li>
                          <li
                            style={{ color: policies.digit ? "green" : "red" }}
                          >
                            At least one digit
                          </li>
                          <li
                            style={{
                              color: policies.special ? "green" : "red",
                            }}
                          >
                            At least one special character
                          </li>
                        </ul>
                      </div>
                    </div>{" "}
                    <div class="col-12 align-items-start col-md-8 login-field align-center mx-2 text-left mb-3">
                      <div class="mr-3">
                        <img src={getImageUrl("icon-lock.svg")} alt="img" />
                      </div>
                      <div class="form-group w-100">
                        <label>Confirm new password</label>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignContent: "center",
                            justifyContent: "flex-end",
                            alignItems: "center",
                          }}
                        >
                          <input
                            aria-valuenow={"New password"}
                            id="confirmPassword"
                            type={showconfirmpassword ? "text" : "password"}
                            value={confirmPassword}
                            onChange={handleConfirmPasswordChange}
                            name="new-password"
                            class="form-control"
                            placeholder="Confirm your new password"
                          />
                          <span
                            onClick={() =>
                              setShowconfirmpassword(!showconfirmpassword)
                            }
                            className="position-absolute end-0 top-50 translate-middle-y me-3 mx-2  cursor-pointer"
                            style={{ cursor: "pointer" }}
                          >
                            {
                              <img
                                src={
                                  !showconfirmpassword
                                    ? getImageUrl("eye-close.svg")
                                    : getImageUrl("eye-open.svg")
                                }
                                alt="img"
                              />
                            }
                          </span>
                        </div>
                        {confirmError && (
                          <p style={{ color: "red" }}>{confirmError}</p>
                        )}
                      </div>
                      
                    </div>
                    <div
                    className="my-40 d-flex col-md-8 "
                    style={{ justifyContent: "center" }}
                  >
                    {/* <button type="button" className="btn btn-light prev-step px-45" onClick={() => setCurrentTab(1)}>
                               Back
                             </button> */}
                    <button
                      type="button"
                      className="btn btn-default next-step px-30"
                      disabled={confirmError || isLoading}
                      onClick={(e) => {
                        handleSubmit(e);
                      }}
                    >
                      {isLoading ? "Reseting..." : "Reset password"}
                    </button>
                  </div>
                  </div>{" "}
                  {/* <div
                    className="my-40 d-flex "
                    style={{ justifyContent: "center" }}
                  >
                  
                    <button
                      type="button"
                      className="btn btn-default next-step px-30"
                      disabled={confirmError || isLoading}
                      onClick={(e) => {
                        handleSubmit(e);
                      }}
                    >
                      {isLoading ? "Reseting..." : "Reset password"}
                    </button>
                  </div> */}
                </form>
              </div>
            </div>
            <div className="row form-default">
              <div className="col-12 col-md-4">
                <div className="form-group"></div>
              </div>
            </div>
          </div>
        </div>
        <ReviewFooter />
      </div>
    </div>
  );
};
